<template>
  <div class="full-page-width" :key="`all-shipments-${$route.query ? $route.query.globalSearchKey : 0}`">
    <div class="all-shipments relative">
      <div class="add-button c-float m-b-20 flex is-flex-wrap">
        <div class="flex" style="flex-grow: 1">
          <p class="user-name">{{ $t('inbound_shipments') }}</p>
        </div>
        <Dropdown
          class="flex drop-right"
          :buttonText="$t('add')"
          :dropdownOptions="dropdownOptions"
          @optionSelected="optionSelected" />
      </div>
      <DataTable
        :dropdown=false
        :tableHeader=false
        :tableHead=true
        tableAPI="SHARED_SHIPMENTS"
        tableActions="SHARED_SHIPMENTS"
        :actionsOptions="actionsOptions"
        :totalCount="totalCount"
        :checkbox=true
        :type=type
        :count="get_shared_shipments_count"
        :list="get_shared_shipments_list"
        :rowActionParameter="rowActionParameter"
        :customTable="tableType"
        :referenceData="referenceData"
        :filterOptions="filterOptions"
        :updateIterator="updateIterator"
        @updatedSelections="tableSelectionsUpdated"
        @actionOptionTriggered="actionOptionTriggered"
        @rowAction="rowAction" />
      <a
        style="display: none"
        :download="`Waybills`"
        ref="downloadWaybillsPDF"
        :href="waybillsPdfPath" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Dropdown from '@/components/global/dropdown';
import Btn from '@/components/elements/buttons';
import DataTable from '@/components/table/index.vue';
import Popup from '@/components/global/popup';
import UploadTemplate from '@/components/global/uploadTemplate';
import EventBus from '@/eventBus.js';

/* eslint-disable */
export default {
  name: 'SharedShipments',
  components: { DataTable, Btn, Dropdown, Popup, UploadTemplate },
  data() {
    return {
      currentPickupIndex: 0, // Index of the currently selected pickup
      shippmentManualCancel: {},
      showManualCancelPopup: false,
      isTableAllSelected: false,
      openImport: false,
      showImportButton: false,
      updateIterator: 1,
      totalCount: 10,
      rowActionParameter: {
        param: 'id',
        text: this.$t('View shipment'),
      },
      type: {
        type: false,
        data: 'status',
      },
      referenceData: [
        {
          created_at: `${this.$t('created_at')}`,
          creator_user_name: `${this.$t('created_by')}`,
        },
        {
          customer_name: `${this.$t('receiver')}`,
          customer_address_country_name: `${this.$t('country')}`,
        },
        {
          sender_reference: `${this.$t('Sender ref.:')}`,
          create_type: `${this.$t('Source')}`,
        },
      ],
      dropdownOptions: [
        {
          text: `${this.$t('Create Shipment')}`,
          subText: `${this.$t('Type in manually')}`,
          icon: 'plus',
        },
      ],
      actionsOptions: [
        {
          text: this.$t('Download waybills'),
          subText: this.$t('Download waybills'),
          icon: 'cloudDownload',
        },
      ],
      waybillsPdfPath: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_error_message',
      'get_shared_shipments_list',
      'get_shared_shipments_count',
      'get_filters_menu',
      'get_active_filter',
      'get_all_shipments_query',
      'get_active_subaccount'
    ]),
    tableType() {
      return 'AllShipments';
    },
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'sharedShipments',
        tableApi: 'shipment/get-shared-list',
        filterFields: {
          status: {
            label: this.$t('status'),
            type: 'select',
            multiselect: true,
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: this.$t('canceled'), value: '5'},
              {text: this.$t('PRINTED'), value: '3'},
              {text: this.$t('Recived by agent'), value: '12'},
              {text: this.$t('on_the_way'), value: '13'},
              {text: this.$t('deviation'), value: '16'},
              {text: this.$t('In pickup point'), value: '15'},
              {text: this.$t('Delivered'), value: '14'},
              {text: this.$t('Waiting for approval'), value: '34'},
              {text: this.$t('Approved'), value: '35'},
            ],
          },
          ship_date: {
            label: this.$t('ship_date'),
            type: 'date',
            range: true,
            value: {
              value: null,
              additional: '',
            },
          },
          created_at: {
            label: this.$t('created_at'),
            type: 'date',
            range: true,
            value: {
              value: null,
              additional: '',
            },
          },
          subaccounts: {
            label: this.$t('account'),
            type: 'subaccount',
            value: {
              value: [],
              additional: '',
            },
          },
          custom_tags: {
            label: this.$t('Tags'),
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          shipping_agents: {
            label: this.$t('shipping_agent_name'),
            type: 'shippingAgent',
            value: {
              value: [],
              additional: '',
            },
          },
          shipping_product_name: {
            label: this.$t('Product name'),
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          weight: {
            label: this.$t('weight'),
            type: 'options',
            value: {
              value: '',
              additional: '',
            },
          },
          goods_type: {
            label: this.$t('goods_type'),
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('parcel')}`, value: '1'},
              {text: `${this.$t('document')}`, value: '2'},
              {text: `${this.$t('pallet')}`, value: '3'},
              {text: `${this.$t('load')}`, value: '4'},
            ],
          },
          receiver_reference: {
            label: `${this.$t('reciever_reference')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_company_name: {
            label: `${this.$t('receiver_company_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_name: {
            label: `${this.$t('receiver_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_address: {
            label: `${this.$t('receiver_address')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_post_code: {
            label: `${this.$t('receiver_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_country_id: {
            label: `${this.$t('receiver_country_id')}`,
            type: 'country',
            noContinent: true,
            value: {
              value: [],
              additional: '',
            },
          },
          sender_reference: {
            label: `${this.$t('sender_reference')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_company_name: {
            label: `${this.$t('sender_company_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_name: {
            label: `${this.$t('sender_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_address: {
            label: `${this.$t('sender_address')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_post_code: {
            label: `${this.$t('sender_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_country_id: {
            label: `${this.$t('sender_country_id')}`,
            type: 'country',
            noContinent: true,
            value: {
              value: [],
              additional: '',
            },
          },
          goods_incoterm: {
            label: `${this.$t('goods_incoterm')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: 'DAP', value: 'DAP'},
              {text: 'DDP', value: 'DDP'},
              {text: 'EXW', value: 'EXW'},
              {text: 'FCA', value: 'FCA'},
              {text: 'CPT', value: 'CPT'},
              {text: 'CIP', value: 'CIP'},
              {text: 'DPU', value: 'DPU'},
              {text: 'FAS', value: 'FAS'},
              {text: 'FOB', value: 'FOB'},
              {text: 'CFR', value: 'CFR'},
              {text: 'CIF', value: 'CIF'},
            ],
          },
          duty_paid_by: {
            label: `${this.$t('duty_paid_by')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('duty_paid_by')} ${this.$t('Seller').toLowerCase()}`, value: '1'},
              {text: `${this.$t('duty_paid_by')} ${this.$t('Reciever').toLowerCase()}`, value: '2'},
              {text: `${this.$t('duty_paid_by')} ${this.$t('Third party').toLowerCase()}`, value: '3'},
            ],
          },
          freight_paid_by: {
            label: `${this.$t('freight_paid_by')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('freight_paid_by')} ${this.$t('Seller').toLowerCase()}`, value: '1'},
              {text: `${this.$t('freight_paid_by')} ${this.$t('Other').toLowerCase()}`, value: '2'},
            ],
          },
          dangerous_goods: {
            label: `${this.$t('dangerous_goods')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
        },
      }
    },
  },
  methods: {
    // Method to handle keeping a pickup
    keepPickup(index) {
      // Remove this pickup from the list without canceling it
      this.emptyPickups.splice(index, 1);

      // If all pickups have been decided upon, close the popup
      if (this.emptyPickups.length === 0) {
        this.closeLastInPickupPopup();
      }
    },
    // Method to handle canceling a pickup
    cancelPickup(pickup, index) {
      console.log(pickup)
      // Cancel the pickup
      this.$store.dispatch('CANCEL_PICKUP', {id: pickup.pickup_id}).then(() => {
        this.updateIterator++;

        // Show notification
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: this.$t('pickup_cancelled_successfully', { number: pickup.id }),
          type: 'success-window',
          iconName: 'check',
        });

        // Remove the cancelled pickup from the list
        this.emptyPickups.splice(index, 1);

        // If all pickups have been decided upon, close the popup
        if (this.emptyPickups.length === 0) {
          this.closeLastInPickupPopup();
        }
      });
    },
    // Method to close the popup
    closeLastInPickupPopup() {
      this.showLastInPickupPopup = false;
      this.emptyPickups = [];
    },
    // Table actions
    tableSelectionsUpdated(val) {
      this.isTableAllSelected = val.selectTotalRows;
    },
    // import
    openImportTemplatePopup() {
      this.openImport = true;
      this.$store.dispatch('GET_TEMPLATES');
    },
    togglePopupEdit() {
      this.openImport = !this.openImport;
    },
    submitForm() {
      EventBus.$emit('import_template');
    },
    enableImport() {
      this.showImportButton = true;
    },
    closePopupAndTrackImportProcess() {
      this.togglePopupEdit();
    },
    // #import
    rowAction(val) {
      this.$router.push(`/view-shipment/${this.listItem.id}`);
    },
    createNewShipment() {
      this.$router.push('/shipments/book-shipment');
    },
    optionSelected(opt) {
      if(opt === 'dropOption1') {
        this.createNewShipment();
      }
      if(opt === 'dropOption2') {
        this.openImportTemplatePopup();
      }
    },
    closeManualCancelPopup() {
      this.showManualCancelPopup = false;
      this.shippmentManualCancel = {};
    },
    actionOptionTriggered(option) {
      if(option.dropOption == 'dropOption1') {
        // Copy to new
        let shipmentId = this.get_shipments_list.filter((item) => item.id == option.list[0])[0].id;
        this.$store.dispatch('GET_SHIPMENT', shipmentId).then((res) => {
          this.$store.dispatch('SET_EDITING_SHIPMENT', res).then(() => {
            this.$router.push('book-shipment');
          });
        });
      }
      if(option.dropOption == 'dropOption2') {
        // Create EOD
        const currentIcon = this.actionsOptions[3].icon;
        this.actionsOptions[3].icon = 'animation';
        this.$store.dispatch('CREATE_EOD', option.list).then(() => {
          this.$router.push('end-of-day');
        });
      }
      if(option.dropOption == 'dropOption3') {
        //Print Waybills

        let ids = option.list
        if (this.isTableAllSelected) {
          ids = this.get_shipments_ids_of_all_records
          if (ids.length === 0) {
            this.$store.commit('SHOW_NOTIFICATION_BAR', {
              message: 'You can select max 500 shipments for this action!',
              type: 'alert-window'
            });
          }
        }

        if (ids.length) {
          this.$store.dispatch('DOWNLOAD_MULTI_LABELS', ids).then((res) => {
            this.$nextTick(() => {
              let file = window.URL.createObjectURL(res);
              this.$refs.downloadWaybillsPDF.href = file;
              this.waybillsPdfPath = file;
              this.$refs.downloadWaybillsPDF.click();
            })
          });
        }
      }
    },
  },
};
</script>
